import AccountVerification from "../pages/Auth/AccountVerification";
import ChangePassword from "../pages/Auth/ChangePassword";
import CheckEmail from "../pages/Auth/CheckEmail";
import ForgotPassword from "../pages/Auth/ForgotPassword";
import ResetPassword from "../pages/Auth/ResetPassword";
import Signin from "../pages/Auth/Signin";
import SignUpNew from "../pages/Auth/SignUpNew";
import AllBooking from "../pages/Booking/AllBooking";
import CareGiverNew from "../pages/CareGiver/CareGiverNew";
import CareGiverProfile from "../pages/CareGiver/CareGiverProfile";
import CareRegistration from "../pages/CareGiver/CareRegistration";
import AllChat from "../pages/Chat/AllChat";
import Chat from "../pages/Chat/Chat";
import ChildCareService from "../pages/ChildCare/ChildCareService";
import AllJobs from "../pages/Jobs/AllJobs";
import CustomerJob from "../pages/Jobs/CustomerJob";
import CustomerJobDetails from "../pages/Jobs/CustomerJobDetails";
import JobDetail from "../pages/Jobs/JobDetail";
import TrackingJob from "../pages/Jobs/TrackingJob";
import EditProfile from "../pages/Profile/EditProfile";
import FavouriteProfile from "../pages/Profile/FavouriteProfile";
import Profile from "../pages/Profile/Profile";
import SingleProfile from "../pages/Profile/SingleProfile";
import Introduce from "../pages/Auth/Introduce";
import CareRegistration2 from "../pages/CareGiver/CareRegistration2";
import CareRegistration3 from "../pages/CareGiver/CareRegistration3";
import CareRegistration4 from "../pages/CareGiver/CareRegistration4";
import CareRegistration5 from "../pages/CareGiver/CareRegistration5";
import AddPayment from "../pages/Payment/AddPayment";
import ViewCard from "../components/Card/ViewCard";
import MyServices from "../pages/CareGiver/MyServices";
import EditService from "../pages/CareGiver/EditService";
import AddServices from "../pages/CareGiver/AddServices";
import Wallet from "../pages/Wallet";
import Terms from "../pages/Terms";
import Documents from "../pages/Documents";

const routes = [
    {
        path: "signin",
        element: <Signin />,
        privateRoute: false,
    },
    {
        path: "signup",
        element: <SignUpNew />,
        privateRoute: false,
    },
    {
        path: "introduce",
        element: <Introduce />,
        privateRoute: false,
    },
    {
        path: "forgot-password",
        element: <ForgotPassword />,
        privateRoute: false,
    },
    {
        path: "account-verification/:email",
        element: <AccountVerification />,
        privateRoute: false,
    },
    {
        path: "reset-password/:email/:code",
        element: <ResetPassword />,
        privateRoute: false,
    },
    {
        path: "change-password",
        element: <ChangePassword />,
        privateRoute: true,
    },
    {
        path: "check-email",
        element: <CheckEmail />,
        privateRoute: false,
    },
    {
        path: "profile",
        element: <Profile />,
        privateRoute: true,
    },
    {
        path: "favorites",
        element: <FavouriteProfile />,
        privateRoute: true,
    },
    {
        path: "edit-profile",
        element: <EditProfile />,
        privateRoute: true,
    },
    {
        path: "favourite-profile",
        element: <FavouriteProfile />,
        privateRoute: true,
    },
    {
        path: "single-profile/:id",
        element: <SingleProfile />,
        privateRoute: true,
    },
    {
        path: "single-profile/:id/:service_id",
        element: <SingleProfile />,
        privateRoute: true,
    },
    {
        path: "all-booking",
        element: <AllBooking />,
        privateRoute: true,
    },
    {
        path: "all-care-giver",
        element: <CareGiverNew />,
        privateRoute: true,
    },
    {
        path: "/care-giver",
        element: <CareGiverNew />,
        privateRoute: true,
    },
    {
        path: "/care-giver/:id",
        element: <CareGiverNew />,
        privateRoute: true,
    },
    {
        path: "care-giver-new",
        element: <CareGiverNew />,
        privateRoute: true,
    },
    {
        path: "care-giver-profile",
        element: <CareGiverProfile />,
        privateRoute: true,
    },
    {
        path: "care-giver-registration",
        element: <CareRegistration />,
        privateRoute: true,
    },
    {
        path: "care-giver-registration-2",
        element: <CareRegistration2 />,
        privateRoute: true,
    },
    {
        path: "care-giver-registration-3",
        element: <CareRegistration3 />,
        privateRoute: true,
    },
    {
        path: "care-giver-registration-4",
        element: <CareRegistration4 />,
        privateRoute: true,
    },
    {
        path: "care-giver-registration-5",
        element: <CareRegistration5 />,
        privateRoute: true,
    },
    {
        path: "my-services",
        element: <MyServices />,
        privateRoute: true,
    },
    {
        path: "edit-service/:id",
        element: <EditService />,
        privateRoute: true,
    },
    {
        path: "add-services",
        element: <AddServices />,
        privateRoute: true,
    },
    {
        path: "add-card",
        element: <AddPayment />,
        privateRoute: true,
    },
    {
        path: "view-card",
        element: <ViewCard />,
        privateRoute: true,
    },
    {
        path: "all-jobs",
        element: <AllJobs />,
        privateRoute: true,
    },
    {
        path: "customer-job",
        element: <CustomerJob />,
        privateRoute: true,
    },
    {
        path: "customer-Job-details",
        element: <CustomerJobDetails />,
        privateRoute: true,
    },
    {
        path: "chat",
        element: <Chat />,
        privateRoute: true,
    },
    {
        path: "all-chat",
        element: <AllChat />,
        privateRoute: true,
    },
    {
        path: "all-chat/:id",
        element: <AllChat />,
        privateRoute: true,
    },
    {
        path: "child-care-service",
        element: <ChildCareService />,
        privateRoute: true,
    },
    {
        path: "job-detail/:id",
        element: <JobDetail />,
        privateRoute: true,
    },
    {
        path: "tracking-job/:id",
        element: <TrackingJob />,
        privateRoute: true,
    },
    {
        path: "wallet",
        element: <Wallet />,
        privateRoute: true,
    },
    {
        path: "documents",
        element: <Documents />,
        privateRoute: true,
    },
];

export default routes;
